import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractService } from '@core/http/abstract.service';

import { ApiResponse } from './notifications.entity';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService extends AbstractService {
  protected override prefix = '/users/notifications';

  getUnread(important: boolean|null = null): Observable<ApiResponse.Notifications> {
    return this.get<ApiResponse.Notifications>('/unread', { important });
  }

  getHistory(): Observable<ApiResponse.Notifications> {
    return this.get<ApiResponse.Notifications>('/archive');
  }

  markAsRead(ids: number[]): Observable<void> {
    return this.post('/mark-as-read', { ids });
  }
}